/**
 * Created by minimus on 01.08.2015.
 */
(function($) {
  const data = samProOptions.data;
  const localeStrings = samProOptions.strings;
  $(document).ready(function() {
    const dm = ej.DataManager(data);
    const grid = $('#welcomeGrid').ejGrid({
      dataSource: dm,
      allowTextWrap: true,
      columns: [
        {field: 'pid', headerText: 'pid', visible: false},
        {field: 'title', headerText: localeStrings.title, width: 200},
        {field: 'description', headerText: localeStrings.desc},
        {field: 'sale_mode', headerText: localeStrings.buy, width: 150},
        {field: 'asize', headerText: localeStrings.size, width: 120},
        {field: 'price', headerText: localeStrings.price, textAlign: ej.TextAlign.Right, width: 100}
      ]
    }).data('ejGrid');
  });
})(jQuery);